var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "hasPermi",
          rawName: "v-hasPermi",
          value: ["platform:merchant:supplier:page:list"],
          expression: "['platform:merchant:supplier:page:list']",
        },
      ],
      staticClass: "divBox",
    },
    [
      _c(
        "el-card",
        {
          staticClass: "ivu-mt",
          attrs: {
            bordered: false,
            shadow: "never",
            "body-style": { padding: 0 },
          },
        },
        [
          _c(
            "div",
            { staticClass: "padding-add" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    size: "small",
                    "label-position": "right",
                    inline: "",
                  },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单号：" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: { size: "small", placeholder: "请输入订单号" },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.getList(1)
                          },
                        },
                        model: {
                          value: _vm.tableFrom.orderNo,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.tableFrom,
                              "orderNo",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "tableFrom.orderNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "供应商名称：" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: {
                          size: "small",
                          placeholder: "请输入供应商名称",
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.getList(1)
                          },
                        },
                        model: {
                          value: _vm.tableFrom.supplierName,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.tableFrom,
                              "supplierName",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "tableFrom.supplierName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "联系人：" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: { size: "small", placeholder: "请输入联系人" },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.getList(1)
                          },
                        },
                        model: {
                          value: _vm.tableFrom.linkman,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.tableFrom,
                              "linkman",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "tableFrom.linkman",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "联系方式：" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: { size: "small", placeholder: "请输入联系方式" },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.getList(1)
                          },
                        },
                        model: {
                          value: _vm.tableFrom.phone,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.tableFrom,
                              "phone",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "tableFrom.phone",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "用户ID：" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: { size: "small", placeholder: "请输入用户ID" },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.getList(1)
                          },
                        },
                        model: {
                          value: _vm.tableFrom.orderUser,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.tableFrom,
                              "orderUser",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "tableFrom.orderUser",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "店铺类型：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            size: "small",
                            placeholder: "请选择店铺类型",
                            clearable: "",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.getList(1)
                            },
                          },
                          model: {
                            value: _vm.tableFrom.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.tableFrom, "type", $$v)
                            },
                            expression: "tableFrom.type",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "全部", value: "" },
                          }),
                          _vm._l(_vm.typeList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            })
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否退款：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            size: "small",
                            placeholder: "请选择退款状态",
                            clearable: "",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.getList(1)
                            },
                          },
                          model: {
                            value: _vm.tableFrom.isRefund,
                            callback: function ($$v) {
                              _vm.$set(_vm.tableFrom, "isRefund", $$v)
                            },
                            expression: "tableFrom.isRefund",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "全部", value: "" },
                          }),
                          _c("el-option", {
                            attrs: { label: "未退款", value: "0" },
                          }),
                          _c("el-option", {
                            attrs: { label: "已退款", value: "1" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.getList(1)
                            },
                          },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.reset()
                            },
                          },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "0 20px 20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c(
            "el-tabs",
            {
              staticClass: "list-tabs",
              on: { "tab-click": _vm.handleTabClick },
              model: {
                value: _vm.tableFrom.orderStatus,
                callback: function ($$v) {
                  _vm.$set(_vm.tableFrom, "orderStatus", $$v)
                },
                expression: "tableFrom.orderStatus",
              },
            },
            [
              _c("el-tab-pane", { attrs: { label: "全部", name: "-1" } }),
              _c("el-tab-pane", { attrs: { label: "待支付", name: "0" } }),
              _c("el-tab-pane", { attrs: { label: "已支付", name: "1" } }),
              _c("el-tab-pane", { attrs: { label: "已完成", name: "2" } }),
              _c("el-tab-pane", { attrs: { label: "审核拒绝", name: "3" } }),
              _c("el-tab-pane", { attrs: { label: "已取消", name: "9" } }),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "mt20",
              attrs: {
                data: _vm.tableData.data,
                size: "small",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", "min-width": "60" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "orderUser",
                  label: "用户ID",
                  "min-width": "100",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "orderNo",
                  label: "订单号",
                  "min-width": "180",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "supplierName",
                  label: "供应商名称",
                  "min-width": "150",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "linkman", label: "联系人", "min-width": "100" },
              }),
              _c("el-table-column", {
                attrs: { prop: "phone", label: "联系方式", "min-width": "130" },
              }),
              _c("el-table-column", {
                attrs: { label: "类型", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.getTypeName(scope.row.type))),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "productPrice",
                  label: "保证金",
                  "min-width": "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { staticClass: "money" }, [
                          _vm._v("¥" + _vm._s(scope.row.productPrice)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "使用抵用券", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.balance && parseFloat(scope.row.balance) > 0
                          ? _c("span", { staticClass: "money" }, [
                              _vm._v("¥" + _vm._s(scope.row.balance)),
                            ])
                          : _c("span", { staticClass: "no-remark" }, [
                              _vm._v("--"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "实付款", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { staticClass: "money" }, [
                          _vm._v("¥" + _vm._s(_vm.getActualPayment(scope.row))),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "orderStatus",
                  label: "订单状态",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.orderStatus === 0
                          ? _c("el-tag", { attrs: { type: "warning" } }, [
                              _vm._v("待支付"),
                            ])
                          : _vm._e(),
                        scope.row.orderStatus === 1
                          ? _c("el-tag", { attrs: { type: "primary" } }, [
                              _vm._v("已支付"),
                            ])
                          : _vm._e(),
                        scope.row.orderStatus === 2
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v("已完成"),
                            ])
                          : _vm._e(),
                        scope.row.orderStatus === 3
                          ? _c("el-tag", { attrs: { type: "danger" } }, [
                              _vm._v("审核拒绝"),
                            ])
                          : _vm._e(),
                        scope.row.orderStatus === 9
                          ? _c("el-tag", { attrs: { type: "info" } }, [
                              _vm._v("已取消"),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "是否退款", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.isRefund === 1
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v("是"),
                            ])
                          : _c("el-tag", { attrs: { type: "info" } }, [
                              _vm._v("否"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "orderTime",
                  label: "创建时间",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "cause",
                  label: "审核备注",
                  "min-width": "150",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.cause
                          ? _c("span", [_vm._v(_vm._s(scope.row.cause))])
                          : _c("span", { staticClass: "no-remark" }, [
                              _vm._v("--"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "60", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.orderStatus === 1
                          ? _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "hasPermi",
                                    rawName: "v-hasPermi",
                                    value: ["platform:merchant:supplier:audit"],
                                    expression:
                                      "['platform:merchant:supplier:audit']",
                                  },
                                ],
                                on: {
                                  click: function ($event) {
                                    return _vm.handleAudit(scope.row)
                                  },
                                },
                              },
                              [_vm._v(" 审核 ")]
                            )
                          : _vm._e(),
                        scope.row.orderStatus === 2 && scope.row.isRefund !== 1
                          ? _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "hasPermi",
                                    rawName: "v-hasPermi",
                                    value: [
                                      "platform:merchant:supplier:refund",
                                    ],
                                    expression:
                                      "['platform:merchant:supplier:refund']",
                                  },
                                ],
                                staticClass: "refund-btn",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleRefund(scope.row)
                                  },
                                },
                              },
                              [_vm._v(" 退款 ")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-sizes": [20, 40, 60, 80],
                  "page-size": _vm.tableFrom.limit,
                  "current-page": _vm.tableFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "供应商审核",
            visible: _vm.auditDialog.visible,
            width: "400px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.auditDialog, "visible", $event)
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "dialog-footer" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "success",
                            loading: _vm.auditDialog.loading,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.submitAudit("pass")
                            },
                          },
                        },
                        [_vm._v("通 过")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "danger",
                            loading: _vm.auditDialog.loading,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.submitAudit("reject")
                            },
                          },
                        },
                        [_vm._v("不通过")]
                      ),
                      _c("el-button", { on: { click: _vm.cancelAudit } }, [
                        _vm._v("取 消"),
                      ]),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "el-form",
            {
              ref: "auditFormRef",
              attrs: { model: _vm.auditDialog.form, "label-width": "80px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "审核备注", prop: "cause" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      placeholder: "不通过时必填，通过时可选",
                      maxlength: "200",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.auditDialog.form.cause,
                      callback: function ($$v) {
                        _vm.$set(_vm.auditDialog.form, "cause", $$v)
                      },
                      expression: "auditDialog.form.cause",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "退款确认",
            visible: _vm.refundDialog.visible,
            width: "400px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.refundDialog, "visible", $event)
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "dialog-footer" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            loading: _vm.refundDialog.loading,
                          },
                          on: { click: _vm.confirmRefund },
                        },
                        [_vm._v("确定退款")]
                      ),
                      _c("el-button", { on: { click: _vm.cancelRefund } }, [
                        _vm._v("取消"),
                      ]),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("div", { staticClass: "refund-content" }, [
            _c("i", {
              staticClass: "el-icon-warning",
              staticStyle: {
                color: "#e6a23c",
                "font-size": "24px",
                "margin-right": "10px",
              },
            }),
            _c("span", [_vm._v("确定要对此订单进行退款操作吗？")]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }